<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listPaymentMethods"
        :title-table="$t('Payment Methods')"
        module="paymentMethodsSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_FORMA_PAGAMENTO_RECEBIMENTO_INSERIR"
        view-permission="ROLE_FORMA_PAGAMENTO_RECEBIMENTO_CONSULTAR"
        edit-permission="ROLE_FORMA_PAGAMENTO_RECEBIMENTO_ATUALIZAR"
        delete-permission="ROLE_FORMA_PAGAMENTO_RECEBIMENTO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormPaymentMethods
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormPaymentMethods from './forms/FormPaymentMethods.vue'

export default {
  name: 'PaymentMethods',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormPaymentMethods,
  },
  computed: {
    ...mapState('paymentMethodsSettingsModule', {
      listPaymentMethods: state => state.listPaymentMethods,
    }),
  },
  // mixins: [mixinsGlobal],
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: this.$t('Description'),
          field: 'descricao',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'paymentMethodsSettingsModule/prepareToEditPaymentMethods',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
